"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _default = function _default(classObj) {
  if (!classObj.classes) {
    throw new Error('AmpApi: expected classObj to have property classes.');
  }

  if (!Array.isArray(classObj.classes)) {
    throw new Error('AmpApi: expected classObj.classes to be an array.');
  }

  return classObj.classes;
};

exports["default"] = _default;